interface ToggleGroupProps<T extends string> {
  options: { label: string; value: T }[];
  activeValue: T;
  onChange: (v: T) => void;
}

const ToggleGroup = <T extends string>({
  options,
  activeValue,
  onChange,
}: ToggleGroupProps<T>) => (
  <div className="flex w-full">
    {options.map((opt, idx) => (
      <button
        key={opt.value}
        onClick={() => onChange(opt.value)}
        className={`flex-1 border py-2 text-sm font-semibold transition-colors ${
          idx === 0 ? "rounded-l-lg" : ""
        } ${idx === options.length - 1 ? "rounded-r-lg" : ""} ${
          activeValue === opt.value
            ? "border-primaryGray-1 bg-primaryGray-1 text-white"
            : "hover:bg-primaryGray-18 border-primaryGray-16 bg-white text-primaryGray-1"
        }`}
      >
        {opt.label}
      </button>
    ))}
  </div>
);

export default ToggleGroup;
